import React from "react";
import Home from "./Pages/Home";

const App = () => {
  return (
    <React.Fragment>
        <Home />
    </React.Fragment>
  );
};

export default App;